import { ActivityStatusSchema } from "@redotech/redo-model/returns/temporal-status";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";

export const getReturnCreationStatus = unaryStreamRpc({
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({ activityStatuses: z.array(ActivityStatusSchema) }),
});
